import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'ms-recent-activity-tag',
  templateUrl: './recent-activity-tag.component.html',
  styleUrls: ['./recent-activity-tag.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class RecentActivityTagComponent {
  @Input() public active: boolean = true;

  public get label(): string {
    return this.active
      ? 'Activité récente'
      : "Pas d’activité au cours des 90 derniers jours";
  }

  public get badgeClass(): string {
    return this.active ? 'override-tag--green' : 'override-tag--red';
  }
}
